import React, { FC, useState } from "react";
import { DEF_PG_SIZE_WIZARD } from "../../constants/maximum-page-size";
import { EVENT_BASED_NOTIFICATION_TYPE_ID, SCHEDULE_NOTIFICATION_TYPE_ID } from "../../constants/notification-key";
import { useLocale } from "../../contexts/localeContext";
import { TableContextProvider } from "../../contexts/table/TableContextProvider";
import { TranslationKeys } from "../../contexts/TranslationKeys";
import ModesColumns from "../../models/ColumnDefinitions/ModeColumns";
import { ListData } from "../../models/ListData";
import { ListQuery } from "../../models/ListQuery";
import ModeSearch from "../../models/search/ModeSearch";
import { getRuleDisplayType } from "../../services/notificationService";
import { appendFilter } from "../../utilities/filters";
import TableTab from "../tabs/table-tab";


interface Props {
    onNext: (event: any) => void;
    setDescription: (discription: string) => void;
}

const NotificationTypeStep: FC<Props> = ({ onNext, setDescription}) => {
    const [taskSelected, setTaskSelected] = useState(false);
    const { translate } = useLocale();

    const onLocalNext = (event: any) => {
        if (event.task) {
            onNext({ ...event, id: event.id, task: event.task });
        }
    };

    const itemSelected = (selectedItem: any) => {
        if (selectedItem) {
            setTaskSelected(true);
            setDescription(selectedItem.label);
            onLocalNext({
                task: selectedItem.nameOriginal,
                id: selectedItem.id,
            });
        }
    };

    /** This method is temporary,
       just to display the supported notifications thus far,
       and hide the unsupported notifications.
     * Adapt this method to add supported notifications by
       adding to the supportedNotificationTypesIds array.
     */
    const getData = (): ((query?: ListQuery) => Promise<ListData>) => {
        const supportedNotificationTypesIds = [SCHEDULE_NOTIFICATION_TYPE_ID, EVENT_BASED_NOTIFICATION_TYPE_ID];
        return (listParameters?: ListQuery) =>
            getRuleDisplayType({
                ...listParameters,
                filters: appendFilter(
                    supportedNotificationTypesIds,
                    "NotificationTypeIds",
                    "id",
                    listParameters?.filters ?? [],
                    "=in=",
                ),
            });
    };

    return (
        <div className="pt-3 pr-3 pl-3 h-full relative ">
            <TableContextProvider
                usePagination
                useTable
                // dataMethod={getRuleDisplayType} // Uncomment this line when all notification types are supported
                dataMethod={getData()} // Remove this line when all notification types are supported
                tableDescriptor={ModesColumns}
                searchDescriptor={ModeSearch}
                disableSearch={true}
                maxPageSize={DEF_PG_SIZE_WIZARD}
                canExportReport={false}>
                <TableTab
                    title={translate.byKey(
                        TranslationKeys.selectNotificationType,
                    )}
                    selectRows={false}
                    onRowClicked={itemSelected}
                    tableId={"scheduleNotificationTable"}
                    cyName="notificationType"/>
            </TableContextProvider>

            <div className="flex flex-row justify-end absolute bottom-0 right-0 pr-3 pb-3 ">
                <div className="flex flex-row justify-end mt-4 pl-3">
                    <button
                        className={`py-1 px-5 secondary ${
                            taskSelected
                                ? "secondary-enabled"
                                : "secondary-disabled cursor-not-allowed"
                        }`}
                        type="button"
                        onClick={(e) => onLocalNext(e)}
                    >
                        {translate.byKey(TranslationKeys.next)}
                    </button>
                </div>
            </div>
        </div>
    );
}

export default NotificationTypeStep;
